/**
 * Utility functions that mimic some of the functionality of lodash.
 * These functions are simple and do not include the full functionality of lodash.
 * They are meant to be lightweight alternatives for common tasks.
 * https://youmightnotneed.com/lodash
 */

export function debounce<T extends (...args: any[]) => void>(func: T, wait: number) {
  let timeout: ReturnType<typeof setTimeout> | null = null;

  return (...args: Parameters<T>) => {
    if (timeout) clearTimeout(timeout);

    timeout = setTimeout(() => {
      func(...args);
    }, wait);
  };
}

export const round = (num: number, precision: number) => {
  const modifier = 10 ** precision;
  return Math.round(num * modifier) / modifier;
};
